// extracted by mini-css-extract-plugin
module.exports = {"root":"IconSuccess_root__3cxnl","fillColor":"IconSuccess_fillColor__1B2c9"};